export default class ChangedOutcomesModifier {
    constructor(modelKeyRepository) {
        this._modelKeyRepository = modelKeyRepository;
    }

    modify(content) {
        if (!content.groups) {
            content.groups = {change: []};
        } else {
            content.groups.change = [];
        }

        if (content.outcomes === undefined || content.outcomes.change === undefined) {
            return;
        }

        const outcomes = content.outcomes.change;

        const groups = [];
        for (let i = 0; i < outcomes.length; i++) {
            const outcome = outcomes[i];
            const groupId = parseInt(`${outcome.e}${outcome.g || 0}`);

            if (!groups.find(g => g === groupId)) {
                groups.push(groupId);
            }
        }

        if (!content.groups) {
            content.groups = {change: groups};
        } else {
            content.groups.change = groups;
        }
    }
}



// WEBPACK FOOTER //
// ./js/repositories/modifier/ChangedOutcomesModifier.js